import React from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";

const DepartmentListTemp = Scrivito.connect(() => (
  <div className="w-100 h-100 d-flex justify-content-center align-items-center">
    Comming soon...
  </div>
));

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    {/* <DepartmentList {...props} /> */}
    <DepartmentListTemp />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("DepartmentList", CheckedPage);
